type Cfg = {
  PORT: number | string
  API_URL: string
  ENVIRONMENT: string
  FORM_BACK_URL: string
  KEYCLOAK_URL: string
  MSF_BACK_URL: string
  APOLLO_SERVER_URL: string
  APOLLO_WS_URL: string
  FRONT_STUDIO_URL: string
  GOOGLE_MAP: string
  AGGRID_LICENCE: string
  RELEASE: string
  BUILD_DATE: string
  SENTRY_DSN?: string
  SENTRY_REPLAY?: boolean
}

declare global {
  interface Window {
    __CONFIG__?: Partial<Cfg>
  }
}

const DEFAULTS: Cfg = {
  PORT: 8080,
  API_URL: "http://localhost:3333",
  ENVIRONMENT: "local",
  FORM_BACK_URL: "http://localhost:8081",
  KEYCLOAK_URL: "http://localhost:3000",
  MSF_BACK_URL: "http://localhost:4444",
  APOLLO_SERVER_URL: "http://localhost:4005",
  APOLLO_WS_URL: "ws://localhost:4005",
  FRONT_STUDIO_URL: "http://localhost:3000",
  GOOGLE_MAP: "",
  AGGRID_LICENCE: "",
  RELEASE: "local",
  BUILD_DATE: "",
  SENTRY_DSN: "",
}

const W = typeof window !== "undefined" ? window : ({} as any)
// Filter out empty strings from __CONFIG__ so they don't override DEFAULTS
const runtimeConfig = Object.fromEntries(
  Object.entries(W.__CONFIG__ || {}).filter(([, v]) => v !== "" && v !== undefined && v !== null)
)
export const config: Cfg = Object.freeze({ ...DEFAULTS, ...runtimeConfig })
export type { Cfg }
